import { render, staticRenderFns } from "./CompactRegulationReviewCard.vue?vue&type=template&id=6e5fd572&scoped=true&"
import script from "./CompactRegulationReviewCard.vue?vue&type=script&lang=js&"
export * from "./CompactRegulationReviewCard.vue?vue&type=script&lang=js&"
import style0 from "./CompactRegulationReviewCard.vue?vue&type=style&index=0&id=6e5fd572&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5fd572",
  null
  
)

export default component.exports